<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Dépôts",
          icon: "bi bi-geo-alt-fill",
          route: "deposits-index",
        },
        {
          label: "Nouveau dépôt",
          icon: "bi bi-plus-circle-fill",
          route: "deposits-create",
        },
      ],
    };
  },
};
</script>
